import RulesField from '../components/rulesfield'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Rules extends React.Component {

  static propTypes = {
    config: PropTypes.object,
    onPop: PropTypes.func,
    onPush: PropTypes.func,
    onUpdate: PropTypes.func
  }

  state = {
    rules: null
  }

  _handleChange = this._handleChange.bind(this)

  render() {
    if(!this.state.rules) return null
    return <Form { ...this._getForm() } />
  }

  componentDidMount() {
    const { config } = this.props
    this.setState({
      rules: _.get(config, 'rules.rules') || []
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { rules } = this.state
    if(!_.isEqual(rules, prevState.rules)) {
      this.props.onUpdate('rules', rules)
    }
  }

  _getForm() {
    const { rules } = this.state
    return {
      onCancel: this._handleDone,
      onChange: this._handleChange,
      showHeader: false,
      sections: [
        {
          fields: [
            { name: 'rules', type: RulesField, fields: this._getFields(), defaultValue: rules }
          ]
        }
      ]
    }
  }

  _getFields() {
    const { fields } = this.props.config
    return fields.map(field => {
      return {
        code: field.code,
        name: field.name?.value,
        type: _.get(field, 'contactfield.type') || field.type,
        options: _.get(field, 'contactfield.options') || field.options
      }
    })
  }

  _handleChange(rules) {
    this.setState({ rules })
  }

}

export default Rules
